// Generated by purs version 0.15.16
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_Modal from "../Widgets.Modal/index.js";
import * as Widgets_Signature from "../Widgets.Signature/index.js";
import * as Widgets_Signature_Email from "../Widgets.Signature.Email/index.js";
import * as Widgets_Signature_Types from "../Widgets.Signature.Types/index.js";
var find = /* #__PURE__ */ Data_Foldable.find(Data_Foldable.foldableArray);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var any = /* #__PURE__ */ Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var SignatureWidgetRequest = /* #__PURE__ */ (function () {
    function SignatureWidgetRequest(value0) {
        this.value0 = value0;
    };
    SignatureWidgetRequest.create = function (value0) {
        return new SignatureWidgetRequest(value0);
    };
    return SignatureWidgetRequest;
})();
var SignatureEmailRequests = /* #__PURE__ */ (function () {
    function SignatureEmailRequests(value0) {
        this.value0 = value0;
    };
    SignatureEmailRequests.create = function (value0) {
        return new SignatureEmailRequests(value0);
    };
    return SignatureEmailRequests;
})();
var SigGroupChanged = /* #__PURE__ */ (function () {
    function SigGroupChanged(value0) {
        this.value0 = value0;
    };
    SigGroupChanged.create = function (value0) {
        return new SigGroupChanged(value0);
    };
    return SigGroupChanged;
})();
var SigGroupMutation = /* #__PURE__ */ (function () {
    function SigGroupMutation(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SigGroupMutation.create = function (value0) {
        return function (value1) {
            return new SigGroupMutation(value0, value1);
        };
    };
    return SigGroupMutation;
})();
var EmailAll = /* #__PURE__ */ (function () {
    function EmailAll() {

    };
    EmailAll.value = new EmailAll();
    return EmailAll;
})();
var updateDefSignatures = function (sgs) {
    return function (defs) {
        var findKey = function (arr) {
            return function (key) {
                return find(function (r) {
                    return eq(r.key)(key);
                })(arr);
            };
        };
        var updateSig = function (ssig) {
            var v = findKey(defs)(ssig.field.key);
            if (v instanceof Data_Maybe.Just) {
                return Widgets_Signature.loadDefaults(Widgets_Signature.AutofillOp.value)(ssig)(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return ssig;
            };
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 88, column 22 - line 90, column 24): " + [ v.constructor.name ]);
        };
        return {
            id: sgs.id,
            docId: sgs.docId,
            account: sgs.account,
            sigs: map(updateSig)(sgs.sigs)
        };
    };
};
var renderSigGroup = function (state) {
    var sigWidget = function (idx) {
        return function (sig) {
            var newSigs = function (sig$prime) {
                return Data_Maybe.fromMaybe(state.sigs)(Data_Array.updateAt(idx)(sig$prime)(state.sigs));
            };
            return bind(Widgets_Signature.signatureWidget(sig))(function (result) {
                if (result instanceof Widgets_Signature.SigWidgetChanged) {
                    return pure(new Data_Either.Left(new SigGroupChanged({
                        id: state.id,
                        docId: state.docId,
                        account: state.account,
                        sigs: newSigs(result.value0)
                    })));
                };
                if (result instanceof Widgets_Signature.SigWidgetMutation) {
                    return pure(new Data_Either.Left(new SigGroupMutation({
                        id: state.id,
                        docId: state.docId,
                        account: state.account,
                        sigs: newSigs(result.value0)
                    }, new SignatureWidgetRequest(result.value1))));
                };
                throw new Error("Failed pattern match at Widgets.Signature.Group (line 121, column 9 - line 125, column 112): " + [ result.constructor.name ]);
            });
        };
    };
    var sigWidgets = Data_Array.mapWithIndex(sigWidget)(state.sigs);
    var actionBtns = div([ Concur_React_Props.className("btn-group btn-group-email") ])(Data_Array.catMaybes([ Internal_Util.justIf(any(function (v) {
        return v.field.can.request;
    })(state.sigs))(button([ Concur_React_Props.className("btn email-all"), voidRight(new Data_Either.Right(EmailAll.value))(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("email-all")) ])) ]));
    return div([ Concur_React_Props.className("signature-group") ])(append(sigWidgets)([ actionBtns ]));
};
var refreshFieldPermissions = function (signatureFields) {
    return function (state) {
        var findKey = function (key) {
            return find(function (field) {
                return eq(field.key)(key);
            })(signatureFields);
        };
        var refreshSig = function (sig) {
            var v = findKey(sig.field.key);
            if (v instanceof Data_Maybe.Just) {
                return Widgets_Signature.loadDefaults(Widgets_Signature.AuthoritativeOp.value)({
                    info: sig.info,
                    docId: sig.docId,
                    signature: sig.signature,
                    field: Widgets_Signature_Types.normalizeDocSigField(v.value0)
                })(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return sig;
            };
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 146, column 22 - line 148, column 23): " + [ v.constructor.name ]);
        };
        return {
            id: state.id,
            docId: state.docId,
            account: state.account,
            sigs: map(refreshSig)(state.sigs)
        };
    };
};
var loadSignatures = function (v) {
    return function (state) {
        var findVerif = function (key) {
            return find(function (r) {
                return eq(r.data.key)(key);
            })(v.verifications);
        };
        var findKey = function (arr) {
            return function (key) {
                return find(function (r) {
                    return eq(r.key)(key);
                })(arr);
            };
        };
        var loadDefs = function (ssig) {
            var v1 = findKey(v.signature_fields)(ssig.field.key);
            if (v1 instanceof Data_Maybe.Just) {
                return Widgets_Signature.loadDefaults(Widgets_Signature.AuthoritativeOp.value)(ssig)(v1.value0);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return ssig;
            };
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 76, column 21 - line 78, column 24): " + [ v1.constructor.name ]);
        };
        var loadVerif = function (ssig) {
            var v1 = findVerif(ssig.field.key);
            if (v1 instanceof Data_Maybe.Just) {
                return Widgets_Signature.loadVerification(ssig)(v1.value0);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return loadDefs(ssig);
            };
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 71, column 22 - line 73, column 33): " + [ v1.constructor.name ]);
        };
        var loadSig = function (ssig) {
            var v1 = findKey(v.signatures)(ssig.field.key);
            if (v1 instanceof Data_Maybe.Just) {
                return Widgets_Signature.loadSignature(ssig)(v1.value0);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return loadVerif(ssig);
            };
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 66, column 20 - line 68, column 34): " + [ v1.constructor.name ]);
        };
        return {
            id: state.id,
            docId: state.docId,
            account: state.account,
            sigs: map(loadSig)(state.sigs)
        };
    };
};
var loadVerifications = function (verifications) {
    return loadSignatures({
        signatures: [  ],
        signature_fields: [  ],
        verifications: verifications
    });
};
var initSigGroup = function (account) {
    return function (id) {
        return function (docId) {
            return function (sigs) {
                return {
                    id: id,
                    docId: docId,
                    sigs: sigs,
                    account: account
                };
            };
        };
    };
};
var handleSGAction = function (state) {
    return function (v) {
        var toEmailEntry = function (v1) {
            return {
                field: v1.field,
                email: v1.info.email,
                selected: false,
                doc: Data_Maybe.Nothing.value
            };
        };
        return bind(Widgets_Modal.modalWidget(renderSigGroup(state))(Widgets_Signature_Email.emailAllForm(state.account)(state.docId)(map(toEmailEntry)(Data_Array.filter(function (v1) {
            return v1.field.can.request;
        })(state.sigs)))))(function (res) {
            if (res instanceof Widgets_Modal.ModalClosed) {
                return pure(new SigGroupChanged(state));
            };
            if (res instanceof Widgets_Modal.ModalReturned) {
                return pure(new SigGroupMutation(state, new SignatureEmailRequests(res.value0)));
            };
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 103, column 5 - line 105, column 98): " + [ res.constructor.name ]);
        });
    };
};
var signatureGroup = function (state) {
    return bind(renderSigGroup(state))(function (v) {
        if (v instanceof Data_Either.Left) {
            return pure(v.value0);
        };
        if (v instanceof Data_Either.Right) {
            return handleSGAction(state)(v.value0);
        };
        throw new Error("Failed pattern match at Widgets.Signature.Group (line 95, column 49 - line 97, column 42): " + [ v.constructor.name ]);
    });
};
export {
    EmailAll,
    SignatureWidgetRequest,
    SignatureEmailRequests,
    SigGroupChanged,
    SigGroupMutation,
    initSigGroup,
    loadVerifications,
    loadSignatures,
    updateDefSignatures,
    signatureGroup,
    handleSGAction,
    renderSigGroup,
    refreshFieldPermissions
};
//# sourceMappingURL=index.js.map
